import { Button, Header, Icon, View } from '@fold-dev/core'
import { TbLayoutSidebar, TbLayoutSidebarFilled } from 'react-icons/tb'
import { useAppStore } from '../store/app'

export const MinimizeHeader = ({ children = null }) => {
    const actions = useAppStore((state) => state.actions)
    const hideNav = useAppStore((state) => state.hideNav)

    return (
        <Header
            height="var(---header-height)"
            p="0 0.75rem"
            width="100%"
            border="0"
            bgToken="surface">
            <View
                row
                width="100%"
                m="0 0rem 0 0"
                gap="0.5rem"
                color="var(--f-color-text-weaker)">
                <Button
                    subtle
                    size="sm"
                    height="2rem"
                    p="0 0.5rem"
                    fontWeight="bold"
                    onClick={() => actions.setHideNav(!hideNav)}
                    colorToken="text-weaker">
                    <Icon 
                        icon={!hideNav ? TbLayoutSidebar : TbLayoutSidebarFilled} 
                        style={!hideNav ? undefined : { '--f-icon-stroke-width-md': '0' }}
                    />
                </Button>
                {children}
            </View>
        </Header>
    )
}
